import estilos from './servicios/Nav.module.css';

function Navb({titulo, className}) {
    return (
       <> 
          <div className={`${estilos.navb} ${className}`}>
          <hr className={estilos.open2}></hr> 
            {titulo}
          <hr className={estilos.open3}></hr>
        </div>

      </>
    );
  };
  
  export default Navb;